var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSuccessSendMessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 210,
  height: 210,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#successSendMessage_svg__a)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 102.714,
  cy: 109,
  fill: "url(#successSendMessage_svg__b)",
  rx: 66.731,
  ry: 66.633
}), /*#__PURE__*/React.createElement("path", {
  fill: "#464649",
  d: "M88.104 7.259c9.223-9.212 24.164-9.212 33.386 0l81.02 80.923c9.238 9.227 9.238 24.198 0 33.425l-80.898 80.802c-9.223 9.211-24.163 9.211-33.386 0l-81.02-80.924c-9.238-9.227-9.238-24.198 0-33.425z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m181.409 67.32 18.238 18.217L85.481 199.804l-18.238-18.216zM151.532 37.283l18.238 18.216L55.604 169.767 37.366 151.55zM122.13 7.934l18.238 18.217L26.203 140.418 7.964 122.202z",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m140.953 182.847-18.249 18.227L8.178 86.924l18.25-18.228zM171.003 153.046l-18.249 18.228L38.228 57.123l18.25-18.228zM200.363 123.718l-18.249 18.228L67.588 27.795l18.25-18.228z",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 104.288,
  cy: 183.142,
  fill: "#191919",
  opacity: 0.2,
  rx: 68.282,
  ry: 4.509
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144.227,
  cy: 67.77,
  r: 1.288,
  fill: "#7B8ECE"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#191919",
  fillRule: "evenodd",
  d: "m47.601 88.098 13.641 11.386.138.961-13.758-11.511s-1.309 20.844-1.309 33.268c0 8.292.584 22.536.971 31.09a7.86 7.86 0 0 0 7.438 7.519c10.78.577 32.324 1.558 53.996 1.558 21.678 0 43.357-.982 54.209-1.558a7.86 7.86 0 0 0 7.446-7.562c.359-8.918.909-24.131.909-33.539 0-13.959-1.211-30.776-1.211-30.776l-15.48 12.952.069-.989 15.334-12.799v-5.447a5 5 0 0 0-1.921-3.939l-11.226-8.776.291-4.116a4 4 0 0 0-3.991-4.282h-1.19v-9.12a6 6 0 0 0-6-6h-19.193l-14.423-11.275a6 6 0 0 0-7.403.01L90.603 46.418H72.927a6 6 0 0 0-6 6v6.688h-2.394a5 5 0 0 0-5 5v6.73l-10.021 7.876a5 5 0 0 0-1.91 3.932zm62.42 51.081h-2.349l1.175.983z",
  clipRule: "evenodd",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEA91B",
  fillRule: "evenodd",
  d: "m45.01 91.275 59.54 49.716 59.539-49.716v-5.237c0-1.538-.708-2.99-1.919-3.939l-54.072-42.286a6 6 0 0 0-7.405.01L46.919 82.099a5 5 0 0 0-1.91 3.931z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E5E5E5",
  fillRule: "evenodd",
  d: "M56.691 140.991V72.267a6 6 0 0 1 6-6h84.626a6 6 0 0 1 6 6v68.724z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2A2A2B",
  fillRule: "evenodd",
  d: "M61.845 119.089V70.267a4 4 0 0 1 4-4h79.607a4 4 0 0 1 4 4v48.822z",
  clipRule: "evenodd",
  opacity: 0.21
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M64.421 140.991V56.567a6 6 0 0 1 6-6h70.115a6 6 0 0 1 6 6v84.424z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("rect", {
  width: 20.613,
  height: 23.19,
  x: 74.657,
  y: 63.97,
  fill: "#FEA91B",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 37.362,
  height: 3.865,
  x: 100.535,
  y: 63.643,
  fill: "#191919",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 37.362,
  height: 3.865,
  x: 100.535,
  y: 72.662,
  fill: "#E5E5E5",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 37.362,
  height: 3.865,
  x: 100.535,
  y: 81.68,
  fill: "#E5E5E5",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 9.018,
  height: 3.865,
  x: 128.879,
  y: 81.68,
  fill: "#191919",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 64.417,
  height: 3.865,
  x: 73.48,
  y: 91.987,
  fill: "#191919",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 64.417,
  height: 3.865,
  x: 73.48,
  y: 101.005,
  fill: "#E5E5E5",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 64.417,
  height: 3.865,
  x: 73.48,
  y: 119.042,
  fill: "#E5E5E5",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 64.417,
  height: 3.865,
  x: 73.48,
  y: 128.06,
  fill: "#E5E5E5",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 42.515,
  height: 3.865,
  x: 73.48,
  y: 110.023,
  fill: "#E5E5E5",
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 14.172,
  height: 3.865,
  x: 73.48,
  y: 110.023,
  fill: "#191919",
  rx: 1.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFC137",
  fillRule: "evenodd",
  d: "M45.01 91.274s-1.274 20.23-1.274 32.287c0 7.979.558 21.636.935 29.96a7.86 7.86 0 0 0 7.439 7.521c10.547.561 31.369 1.502 52.314 1.502 20.953 0 41.905-.942 52.522-1.502a7.86 7.86 0 0 0 7.446-7.562c.349-8.682.876-23.281.876-32.337 0-13.547-1.179-29.869-1.179-29.869l-59.539 49.717z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEA91B",
  fillRule: "evenodd",
  d: "m91.256 129.891 10.541-7.07a5 5 0 0 1 5.525-.03l10.659 6.985 42.658 29.161s-.303.236-.46.348a10.27 10.27 0 0 1-5.431 1.901 934 934 0 0 1-50.324 1.358q-25.151 0-50.126-1.357a10.3 10.3 0 0 1-5.506-1.958c-.223-.162-.647-.512-.647-.512z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M51.293 120.33v27.118M51.293 108.735v5.153M165.268 76.527l2.576-3.865M169.444 89.093l3.865 1.082M169.994 82.007l9.018-2.577M41.16 78.142l-2.577-5.153M37.295 89.766l-6.442 1.231M37.295 83.295l-9.019-3.865"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161.043,
  cy: 154.601,
  r: 21.902,
  fill: "#58CA8C",
  stroke: "#fff",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "m153.313 155.456 5.27 5.162 10.614-12.458"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "successSendMessage_svg__b",
  x1: 118.482,
  x2: 37.331,
  y1: 19.189,
  y2: 98.2,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EBEBEB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "successSendMessage_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h210v210H0z"
})))));
export { SvgSuccessSendMessage as ReactComponent };
export default "data:image/svg+xml;base64,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";